import React from 'react'
import { Link } from 'react-router-dom'
import WhatsAppImage from '../images/whatsapp-chat.svg'
import './Footer.css'

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About MoRecharz</h3>
            <p>Fast and secure mobile recharge service for all major telecom operators. Get instant recharge with best offers and 24/7 support.</p>
            <Link to="/about" className="brand-link">Learn more</Link>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/data-deletion">Data Deletion</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <p className="contact-item contact-channels">
              <a href="https://wa.me/917655062254" target="_blank" rel="noopener noreferrer">
                <img src={WhatsAppImage} alt="Chat on WhatsApp"/>
              </a>
            </p>
            <p className="contact-item contact-channels">
              <a href="mailto:support@morecharz.com" className="contact-link">
                <span className="material-icons contact-icon" aria-hidden="true">email</span>
                support@morecharz.com
              </a>
            </p>
            <p className="contact-item contact-channels">
              <Link to="/contact" className="contact-link"><span className="material-icons contact-icon" aria-hidden="true">assignment</span> Send Message</Link>
            </p>

          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="#" className="social-link">Facebook</a>
              <a href="#" className="social-link">Twitter</a>
              <a href="#" className="social-link">Instagram</a>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2026 MoRecharz. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/terms">Terms &amp; Conditions</Link>
              <span className="divider">•</span>
              <Link to="/privacy">Privacy Policy</Link>
              <span className="divider">•</span>
              <Link to="/data-deletion">Data Deletion</Link>
              <span className="divider">•</span>
              <Link to="/about">About Us</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
